export class ApproveRejectRequests {
    constructor(pendingRequestRepository) {
      this.pendingRequestRepository = pendingRequestRepository;
    }
  
    async execute(requests) {
        debugger;
      return await this.pendingRequestRepository.approveRejectRequests(requests);
    }
  }